import { get, post, put } from './fetcher';

const ADMIN_USER_ENDPOINTS = {
  GET_USERS: '/api/admin/users',
  GET_USER_DETAIL: (userId) => `/api/admin/users/${userId}`,
  APPROVE_USER: (userId) => `/api/admin/users/${userId}/approve`,
  UPDATE_USER: (userId) => `/api/admin/users/${userId}`,
};

export const getAdminUserList = async (token, params = {}) => {
  const queryParams = {};

  if (params.userId) queryParams.userId = params.userId;
  if (params.email) queryParams.email = params.email;
  if (params.userName) queryParams.userName = params.userName;
  if (params.status) queryParams.status = params.status;
  if (params.userType) queryParams.userType = params.userType;
  if (params.isAdmin !== undefined) queryParams.isAdmin = params.isAdmin;
  if (params.approvedYn) queryParams.approvedYn = params.approvedYn;
  if (params.pageNumber) queryParams.pageNumber = params.pageNumber;
  if (params.pageSize) queryParams.pageSize = params.pageSize;

  const response = await get(ADMIN_USER_ENDPOINTS.GET_USERS, queryParams, token);

  if (response.success) {
    return response.data;
  }
  throw new Error(response.message || '사용자 목록 조회에 실패했습니다.');
};

export const getAdminUserDetail = async (token, userId) => {
  const response = await get(ADMIN_USER_ENDPOINTS.GET_USER_DETAIL(userId), {}, token);

  if (response.success) {
    return response.data;
  }
  throw new Error(response.message || '사용자 상세 조회에 실패했습니다.');
};

export const approveAdminUser = async (token, userId) => {
  const response = await post(ADMIN_USER_ENDPOINTS.APPROVE_USER(userId), {}, token);

  if (response.success) {
    return response.data;
  }
  throw new Error(response.message || '승인 처리에 실패했습니다.');
};

export const updateAdminUser = async (token, userId, payload) => {
  const response = await put(ADMIN_USER_ENDPOINTS.UPDATE_USER(userId), payload, token);

  if (response.success) {
    return response.data;
  }
  throw new Error(response.message || '사용자 정보 수정에 실패했습니다.');
};
